import { motion } from 'framer-motion';
import { ShieldCheck, ChevronRight } from 'lucide-react';
import { useState, useEffect } from 'react';

const LAPTOP_IMG = 'https://customer-assets.emergentagent.com/job_acella-onboard-flow/artifacts/jh85va34_OTP.jpg';

export default function NewUserOTPScene({ onNext }) {
  const [digits, setDigits] = useState(['', '', '', '', '', '']);
  const [timer, setTimer] = useState(119);
  useEffect(() => {
    const target = ['3', '9', '5', '2', '0', '8'];
    const otpTimers = target.map((d, i) =>
      setTimeout(() => setDigits(prev => { const n = [...prev]; n[i] = d; return n; }), 1500 + i * 300)
    );
    return () => otpTimers.forEach(clearTimeout);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => setTimer(t => (t > 0 ? t - 1 : 0)), 1000);
    return () => clearInterval(interval);
  }, []);

  const mins = Math.floor(timer / 60);
  const secs = timer % 60;

  return (
    <div data-testid="scene-new-user-otp" className="flex flex-col items-center justify-center h-full px-8">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="w-full max-w-3xl">
        <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-6">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-body font-medium bg-teal-600/10 text-teal-700 mb-3">
            <ShieldCheck size={14} /> New User Flow
          </span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-[#0A0A0A]">Verify Email</h2>
          <p className="mt-2 font-body text-base text-[#737373]">Enter the OTP code sent to your email</p>
        </motion.div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.15 }}
          className="text-[12px] font-body text-[#737373] mb-4">
          Home <ChevronRight size={12} className="inline" /> <span className="font-medium text-[#0A0A0A]">Sign-in</span>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 20, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="bg-white rounded-2xl border border-black/5 shadow-2xl overflow-hidden flex"
        >
          {/* Form side */}
          <div className="flex-1 p-10 flex flex-col justify-center">
            <motion.h3 initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }}
              className="font-heading font-medium text-2xl text-[#0A0A0A] mb-1">
              Welcome Abdul
            </motion.h3>
            <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.6 }}
              className="font-body font-bold text-base text-[#0A0A0A] mb-2">
              Verify your email
            </motion.p>
            <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.7 }}
              className="font-body text-sm text-[#737373] mb-6">
              Enter the code sent to your email a*****@xyz.com
            </motion.p>

            {/* OTP boxes */}
            <div className="flex gap-3 mb-5">
              {digits.map((d, i) => (
                <motion.div key={i}
                  initial={{ scale: 0.9, opacity: 0.3 }}
                  animate={{ scale: d ? 1 : 0.95, opacity: d ? 1 : 0.4, borderColor: d ? '#0D9488' : '#E5E7EB' }}
                  className="w-12 h-14 rounded-lg border-2 flex items-center justify-center bg-[#FAFAFA]"
                >
                  <span className="font-heading font-bold text-xl text-[#0A0A0A]">{d}</span>
                </motion.div>
              ))}
            </div>

            <motion.button initial={{ opacity: 0 }} animate={{ opacity: digits.every(d => d) ? 1 : 0.5 }} transition={{ delay: 0.8 }}
              onClick={onNext}
              className="w-full py-3 rounded-lg bg-teal-600 text-white font-body font-bold text-sm mb-4 cursor-pointer">
              Verify
            </motion.button>

            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.0 }}
              className="flex items-center gap-2 text-sm font-body">
              <span className="text-[#737373]">Didn't receive the code?</span>
              <span className="text-teal-600 font-medium cursor-pointer">Resend</span>
              <span className="text-[#737373] ml-2">{mins}:{secs.toString().padStart(2, '0')}</span>
            </motion.div>
          </div>

          {/* Image side - cropped from user's screenshot */}
          <div className="w-[320px] flex-shrink-0 hidden md:block overflow-hidden">
            <img src={LAPTOP_IMG} alt="OTP verify" className="w-full h-full object-cover object-[85%_center]" style={{ transform: 'scale(2.2)' }} />
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
}
